<template>
  <div class="diagnosis-app">
    <!-- 背景层 -->
    <DiagnosisBackground />

    <!-- 应用主体 -->
    <div class="diagnosis-app-wrapper">
      <!-- 顶部状态栏 -->
      <div class="diagnosis-topbar">
        <span class="sys-label"><span class="live-dot"></span>渠道诊断系统</span>
        <span>状态：<span class="val" style="color:var(--green);">正常运行</span></span>
        <span style="margin-left:auto;">模块：<span class="val">AI诊断 v6.0</span></span>
        <span>时间戳：<span class="val">{{ currentTime }}</span></span>
      </div>

      <!-- 标题头 -->
      <div class="diagnosis-header">
        <div class="h-tag"><span></span>NEURAL DIAGNOSTIC SYSTEM · v6.0</div>
        <h1>渠道结构<span class="sep">·</span><span class="accent">AI智能诊断</span></h1>
        <p class="subtitle">输入品牌名，AI自动调研各电商平台覆盖情况、DTC渠道布局、分销体系等18项指标，直接生成诊断报告与优化建议。</p>
        <div class="h-stats">
          <div class="h-stat"><span class="h-dot"></span><span class="h-num">06</span>维度模型</div>
          <div class="h-stat"><span class="h-dot cyan"></span><span class="h-num">18</span>诊断指标</div>
          <div class="h-stat"><span class="h-dot"></span><span class="h-num">04</span>阶段策略</div>
          <div class="h-stat"><span class="h-dot cyan"></span><span class="h-num">AI</span>自动评分</div>
        </div>
      </div>

      <!-- 导航栏 -->
      <div class="diagnosis-nav">
        <button
          v-for="tab in tabs"
          :key="tab.id"
          class="nav-btn"
          :class="{ active: activeTab === tab.id }"
          :disabled="diagnosisStatus === 'loading'"
          @click="switchTab(tab.id)"
        >
          <span class="n-num">{{ tab.num }}</span>{{ tab.label }}
        </button>
      </div>

      <!-- Tab 内容区 -->
      <div class="diagnosis-tab" :key="activeTab">
        <AiDiagnosisTab v-if="activeTab === 'ai'" @diagnosis-complete="onDiagnosisComplete" />
        <TheoryTab v-if="activeTab === 'theory'" />
        <ScoresTab v-if="activeTab === 'scores'" />
        <ReportTab v-if="activeTab === 'report'" @switch-tab="switchTab" />
        <RecTab v-if="activeTab === 'recommendations'" />
      </div>
    </div>

    <!-- 评分调整弹窗 -->
    <AdjustModal />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import DiagnosisBackground from './components/Background/index.vue'
import AiDiagnosisTab from './components/AiDiagnosis/AiDiagnosisTab.vue'
import TheoryTab from './components/Theory/TheoryTab.vue'
import ScoresTab from './components/ScoreDetail/ScoresTab.vue'
import ReportTab from './components/Report/ReportTab.vue'
import RecTab from './components/Recommendations/RecTab.vue'
import AdjustModal from './components/Popups/AdjustModal.vue'

export default {
  name: 'ChannelDiagnosis',
  components: {
    DiagnosisBackground,
    AiDiagnosisTab,
    TheoryTab,
    ScoresTab,
    ReportTab,
    RecTab,
    AdjustModal
  },
  data() {
    return {
      currentTime: '',
      clockTimer: null,
      tabs: [
        { id: 'ai', num: '00 / AI', label: 'AI诊断' },
        { id: 'theory', num: '01 / THEORY', label: '理论基础' },
        { id: 'scores', num: '02 / SCORES', label: '评分详情' },
        { id: 'report', num: '03 / REPORT', label: '诊断报告' },
        { id: 'recommendations', num: '04 / ACTIONS', label: '优化建议' }
      ]
    }
  },
  computed: {
    ...mapState('diagnosis', ['activeTab', 'diagnosisStatus'])
  },
  mounted() {
    // 实时时钟
    this.clockTimer = setInterval(() => {
      this.currentTime = new Date().toISOString().replace('T', ' ').slice(0, 19) + ' UTC'
    }, 1000)
  },
  beforeDestroy() {
    if (this.clockTimer) clearInterval(this.clockTimer)
  },
  methods: {
    ...mapActions('diagnosis', ['switchTab', 'resetAll']),
    onDiagnosisComplete() {
      this.switchTab('report')
    }
  }
}
</script>

<style src="./styles/diagnosis.css"></style>
